<div>
  <h2 mat-dialog-title>Sensor sensitivity</h2>
  <mat-dialog-content fusePerfectScrollbar [fusePerfectScrollbarOptions]="{ suppressScrollX: true }">
    <div class="slider-label-left">Less Sensitive</div>
    <mat-slider min="1" max="10" thumbLabel step="1" tickInterval="1" [value]="sensitivity" (change)="onChange($event)" [disabled]="closeDisabled"></mat-slider>
    <div class="slider-label-right">More Sensitive</div>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="mt-12">
      <button mat-button mat-dialog-close [disabled]="closeDisabled">Close</button>
      <button mat-button (click)="save()" [disabled]="closeDisabled">Save</button>
  </mat-dialog-actions>
</div>
  